module.exports = __webpack_public_path__ + "img/hombre.47305402.png";